import {UserType} from '../../../util/uiconstants';

const PO = 'projectOwner';
const IEA = 'internalEntityAdmin';
const EEA = 'externalEntityAdmin';
const INT = 'internal';
const EXT = 'external';

const addContactRoles = [PO, IEA, EEA];
const accessLogRoles = [PO, IEA, EEA];
const messageLogRoles = [PO, IEA, INT];
const customizeTableRoles = [PO, IEA, EEA, INT, EXT];
const exportTableRoles = [PO, IEA, EEA, INT, EXT];
const manageAccessRoles = [PO, IEA, EEA];
const defineAttributesRoles = [PO, IEA, EEA];
const tagsRoles = [PO, IEA, EEA];
const generateMessageRoles = [PO, IEA, INT];
const removeContactRoles = [PO, IEA, EEA];
const selectContactRoles = [PO, IEA, EEA, INT];

export default ({userPreferences, entities, userList = null}) => {
	let role;

	const {gui: userGui, userType} = userPreferences;

	const userData = userList?.find(({userId}) => userId === userGui);
	const entityAdminsList = entities?.map(({entityAdmins}) => entityAdmins).flat();
	const isInternal = userType === UserType.Member;
	const isProjectOwner = !!userData?.isProjectOwner;
	const isEntityAdmin = entityAdminsList?.some((x) => x != null && x.userId === userGui);

	if (isInternal) role = INT;
	if (!isInternal) role = EXT;
	if (isEntityAdmin && isInternal) role = IEA;
	if (isEntityAdmin && !isInternal) role = EEA;
	if (isProjectOwner && isInternal) role = PO;

	return {
		addContactPermission: addContactRoles.includes(role),
		accessLogPermission: accessLogRoles.includes(role),
		messageLogPermission: messageLogRoles.includes(role),
		customizeTablePermission: customizeTableRoles.includes(role),
		exportTablePermission: exportTableRoles.includes(role),
		manageAccessPermission: manageAccessRoles.includes(role),
		defineAttributesPermission: defineAttributesRoles.includes(role),
		tagsPermission: tagsRoles.includes(role),
		generateMessagePermission: generateMessageRoles.includes(role),
		removeContactPermission: removeContactRoles.includes(role),
		selectContactPermission: selectContactRoles.includes(role)
	};
};
